<template>
  <div id="loading-dashabord" class="vs-con-loading__container">
    <div class="" v-if="cell !== null">
      <div class="" content="width=device-width, initial-scale=1.0">
        <div class="flex flex-wrap">
          <vs-row style="margin-bottom: 1rem">
            <vs-col vs-align="flex-start" vs-type="flex" vs-justify="end">
              <h1 class="">
                <feather-icon
                  icon="Maximize2Icon"
                  class="inline-block ml-2"
                  svgClasses="w-6 h-6"
                  @click="fullscreen"
                />
              </h1>
            </vs-col>
          </vs-row>

          <vs-row
            vs-align="flex-start"
            vs-type="flex"
            vs-justify="center"
            vs-w="12"
          >
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="4"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-row>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                  vs-xs="12"
                  class="px-4"
                >
                  <headcount-indicator
                    class="cardHeigth w-full"
                    @click="showCard('headcount', $event)"
                    style="font-weight: bold; font-size: 1vm !important"
                  />
                </vs-col>

                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                  vs-xs="12"
                  class="px-4"
                >
                  <direct-indicator
                    class="cardHeigth w-full"
                    @click="showCard('direct', $event)"
                    style="font-weight: bold; font-size: 1vm !important"
                  />
                </vs-col>

                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                  vs-xs="12"
                  class="px-4"
                >
                  <indirect-indicator
                    class="cardHeigth w-full"
                    @click="showCard('indirect', $event)"
                    style="font-weight: bold; font-size: 1vm !important"
                  />
                </vs-col>

                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                  vs-xs="12"
                  class="px-4"
                >
                  <complementary-indicator
                    @click="showCard('complementary', $event)"
                    class="cardHeigth w-full"
                    style="font-weight: bold; font-size: 1vm !important"
                  />
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="4"
              vs-sm="12"
              vs-xs="12"
              class="px-2"
            >
              <ehs-donut
                @click="showCard('ehs', $event)"
                class="w-full px-2"
                v-if="hasPermission(['IU EHS VIEW'])"
              />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="4"
              vs-sm="12"
              vs-xs="12"
              class="px-2"
            >
              <compliance-donut
                @click="showCard('compliance', $event)"
                class="w-full px-2"
                v-if="hasPermission(['IU COMPLIANCE VIEW'])"
              />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="4"
              vs-sm="12"
              vs-xs="12"
              class="px-2"
            >
              <pending-expense-donut
                @click="showCard('expense', $event)"
                class="w-full px-2"
                v-if="hasPermission(['IU ACCOUNTING VIEW'])"
              />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="4"
              vs-sm="12"
              vs-xs="12"
              class="px-2"
            >
              <invoiced-expense-donut
                @click="showCard('expense', $event)"
                class="w-full px-2"
                v-if="hasPermission(['IU ACCOUNTING VIEW'])"
              />
            </vs-col>

            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="4"
              vs-sm="12"
              vs-xs="12"
              class="px-2"
            >
              <entry-donut
                @click="showCard('entry', $event)"
                class="w-full px-2"
                v-if="hasPermission(['IU ENTRY VIEW'])"
              />
            </vs-col>
          </vs-row>
          
        </div>
      </div>
      <div>
            <vs-row vs-w="12">
              <vs-col>
                <ehs-card
                  v-if="cards.ehs"
                  :data="data"
                  @close="close('ehs')"
                  class="w-full px-4"
                />
                <compliance-card
                  v-if="cards.compliance"
                  :data="data"
                  @close="close('compliance')"
                  class="w-full px-4"
                />
                <expense-card
                  v-if="cards.expense"
                  :data="data"
                  @close="close('expense')"
                  class="w-full px-4"
                />
                <entry-card
                  v-if="cards.entry"
                  :data="data"
                  @close="close('entry')"
                  class="w-full px-4"
                />
                <headcount-card
                  :data="data"
                  v-if="cards.headcount"
                  @close="close('headcount')"
                  class="w-full px-4"
                />
                <direct-required-card
                  :data="data"
                  v-if="cards.direct"
                  @close="close('direct')"
                  class="w-full px-4"
                />
                <indirect-required-card
                  :data="data"
                  v-if="cards.indirect"
                  @close="close('indirect')"
                  class="w-full px-4"
                />
                <complementary-payrolls-card
                  :data="data"
                  v-if="cards.complementary"
                  @close="close('complementary')"
                  class="w-full px-4"
                />
              </vs-col>
            </vs-row>
          </div>
    </div>
    <div v-else>
      <div class="h-screen flex w-full bg-img">
        <div
          class="
            vx-col
            flex
            items-center
            justify-center
            flex-col
            sm:w-1/2
            md:w-3/5
            lg:w-3/4
            xl:w-1/2
            mx-auto
            text-center
          "
        >
          <img
            src="@/assets/images/pages/maintenance-2.png"
            alt="graphic-maintenance"
            class="mx-auto mb-4"
          />
          <h1 class="sm:mx-0 mx-4 mb-6 text-5xl d-theme-heading-color">
            {{ msg }}
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ComplianceDonut from './charts/ComplianceDonut.vue'
import PendingExpenseDonut from './charts/PendingExpensesDonut.vue'
import InvoicedExpenseDonut from './charts/InvoicedExpensesDonut.vue'
import EhsDonut from './charts/EhsDonut.vue'
import EntryDonut from './charts/EntryDonut.vue'

import HeadcountIndicator from './charts/HeadcountIndicator.vue'
import DirectIndicator from './charts/DirectIndicator.vue'
import IndirectIndicator from './charts/IndirectIndicator.vue'
import ComplementaryIndicator from './charts/ComplementaryIndicator.vue'

import RhCards from './components/RhCards.vue'

import EhsCard from './cards/EhsCard.vue'
import ComplianceCard from './cards/ComplianceCard.vue'
import ExpenseCard from './cards/ExpenseCard.vue'
import EntryCard from './cards/EntryCard.vue'
import HeadcountCard from './cards/HeadcountCard.vue'
import DirectRequiredCard from './cards/DirectRequiredCard.vue'
import IndirectRequiredCard from './cards/IndirectRequiredCard.vue'
import ComplementaryPayrollsCard from './cards/ComplementaryPayrollsCard.vue'
import dashboard from '@/http/requests/dashboard'

export default {
  components: {
    ComplianceDonut,
    PendingExpenseDonut,
    EhsDonut,
    EntryDonut,
    RhCards,
    InvoicedExpenseDonut,
    EhsCard,
    ComplianceCard,
    ExpenseCard,
    EntryCard,
    HeadcountCard,
    DirectRequiredCard,
    IndirectRequiredCard,
    ComplementaryPayrollsCard,
    HeadcountIndicator,
    DirectIndicator,
    IndirectIndicator,
    ComplementaryIndicator,
  },
  data() {
    return {
      cell: null,
      msg: '',
      data: {},
      cards: {
        ehs: false,
        compliance: false,
        expense: false,
        entry: false,
        headcount: false,
        direct: false,
        indirect: false,
        complementary: false,
      },
      defaultCards: {
        ehs: false,
        compliance: false,
        expense: false,
        entry: false,
        headcount: false,
        direct: false,
        indirect: false,
        complementary: false,
      },
      loading: false,
    }
  },
  methods: {
    close(card) {
      this.cards[card] = false
    },
    getCellId() {
      this.loading = true
      dashboard
        .getCellId()
        .then((response) => {
          this.cell = response.data.cell
          this.loading = false
        })
        .catch((response) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.loading = false
        })
    },
    showCard(card, event) {
      this.clear()
      this.data = { ...event }
      this.cards[card] = true
    },
    clear() {
      Object.assign(this.cards, this.defaultCards)
      Object.assign(this.data, {})
    },

    showComplianceCard(e) {
      this.clear()
      this.data.statusId = e
      this.cards.compliance = true
    },
    showEntriCard(e) {
      this.clear()
      this.data.ClientName = e
      this.cards.entri = true
    },
    showExpenseCard(e) {
      this.clear()
      this.data = e
      this.cards.expense = true
    },

    showRHCard(e) {
      this.clear()
      if (e == 'headcount') {
        this.showCard('headcount', e)
        this.cards.headcount = true
      }
      if (e == 'direct') {
        this.showCard('direct', e)
        this.cards.direct = true
      }
      if (e == 'indirect') {
        this.showCard('indirect', e)
        this.cards.indirect = true
      }
      if (e == 'complementary') {
        this.showCard('complementary', e)
        this.cards.complementary = true
      }
    },
    fullscreen() {
      this.$router.push({ path: '/dashboard-tv' })
    },
  },
  mounted() {
    this.getCellId()
  },
  watch: {
    loading(val) {
      if (val) {
        this.msg = 'Cargando...'
        this.$vs.loading({
          container: `#loading-dashabord`,
          scale: 0.45,
        })
      } else {
        this.msg = 'No cuenta con celda asignada.'
        this.$vs.loading.close(`#loading-dashabord > .con-vs-loading`)
      }
    },
  },
}
</script>
<style>
.altura {
  height: 43vh !important;
}
.card-value {
  font-weight: bold;
}
.cardHeigth {
  height: 10vh !important;
  font-size: 1.3em;
}
/* @media(max-width:400px){
  .cardHeigth {
  height: 20vh !important;
  font-size: 1.4em;
}
} */
.letrasNegras {
  color: black;
  font-weight: bold;
}
.colorBoxH {
  padding: 9px;
  border-radius: 6px;
  color: rgb(112, 101, 236);
  background: rgba(112, 101, 236, 0.25);
}
.colorBoxD {
  padding: 9px;
  border-radius: 6px;
  color: rgb(27, 200, 117);
  background: rgba(27, 200, 117, 0.25);
}
.colorBoxI {
  padding: 9px;
  border-radius: 6px;
  color: rgb(255, 159, 74);
  background: rgba(255, 159, 74, 0.25);
}
.colorBoxC {
  padding: 9px;
  border-radius: 6px;
  color: rgb(7, 181, 201);
  background: rgba(7, 181, 201, 0.25);
}
</style>
